__turbopack_context__.v({
  "banner": "Ddwrda_banner",
  "floatWrap": "Ddwrda_floatWrap",
  "overlayHero": "Ddwrda_overlayHero",
  "panel": "Ddwrda_panel",
  "tooltip": "Ddwrda_tooltip",
  "wrapper": "Ddwrda_wrapper",
});
